import * as Yup from "yup";

export const createSchema = Yup.object().shape({
  FirstName: Yup.string().required("First name is required"),
  Email: Yup.string()
    .required("Email is required")
    .email(),
  Group: Yup.string().required("You must select a group"),
});

export const editSchema = Yup.object().shape({
  FirstName: Yup.string().required("First name is required"),
  Email: Yup.string()
    .required("Email is required")
    .email(),
  Group: Yup.string().required("You must select a group"),
});

export const schema = Yup.object({
  attributes: Yup.object({
    Name: Yup.string().required("Group Name is required"),
  }),
});
